import { Component, OnInit} from '@angular/core';
import { ActivatedRoute, Router} from '@angular/router';
import { EstudioService} from '../../estudio.service';
import { MatDialog } from '@angular/material/dialog';
import { RetroalimentacionMiEvaluacionComponent} from '../retroalimentacion-mi-evaluacion/retroalimentacion-mi-evaluacion.component';

@Component({
  selector: 'retroalimentacion-alumno',
  standalone: false,
  templateUrl: 'retroalimentacion-alumno.component.html',
  styleUrls: ['../retroalimentacion.component.scss']
})

export class RetroalimentacionAlumnoComponent implements OnInit {

  alumnoID;
  eventoUnidadID;
  unidadID;
  commentTargetID;

  dataRetroalimentacion;
  comentarios;
  evaluacionMetas = [];

  enableComentario = false;

  constructor(private route: ActivatedRoute,
              private router: Router,
              public matDialog: MatDialog,
              private estudioService: EstudioService) {
  }

  ngOnInit() {
    this.eventoUnidadID = this.route.snapshot.paramMap.get('eventoUnidadID');
    this.unidadID = this.route.parent.snapshot.paramMap.get('id');
    this.alumnoID = this.route.pathFromRoot.find(routeFromRoot => {
      return routeFromRoot.snapshot.params.hasOwnProperty('hijoID');
    });
    this.alumnoID = this.alumnoID.snapshot.params.hijoID;

    this.estudioService.getEventoDataRetroalimentacion(this.eventoUnidadID, this.alumnoID).subscribe(res => {
      this.dataRetroalimentacion = this.estudioService.extractData(res);
      const materia = this.dataRetroalimentacion.materias.filter(currMateria => {
        return currMateria.alumnos.length > 0;
      });
      const alumno = materia[0].alumnos[0];
      this.commentTargetID = alumno.eventoAlumnoId;
      this.comentarios = alumno.comentarios;
      this.enableComentario = true;

      // this.extractMetasEval(alumno, materia[0].fechas);
      this.processMetas(materia[0].fechas, alumno);
    });
  }

  processMetas(fechas, alumno) {
    let normalDate = '';
    this.dataRetroalimentacion.metas.map(metaOrigen => {
      const currMeta = Object.assign({}, metaOrigen);
      currMeta.criterios = [];
      metaOrigen.criterios.map(criterioPadreOrigen => {
        const currCriterio = Object.assign({}, criterioPadreOrigen);
        currCriterio.niveles = [];
        criterioPadreOrigen.niveles.map(nivelOrigen => {
          const currNivel = Object.assign({}, nivelOrigen);
          if (!currNivel.hasOwnProperty('fechas')) {
            currNivel.fechas = [];
          }
          fechas.map(fecha => {
            normalDate = fecha.substring(0, 10);
            currNivel.fechas.push({
              label: normalDate,
              criterios: Object.assign([], nivelOrigen.criterios)
            });
          });
          currCriterio.niveles.push(currNivel);
        });
        currMeta.criterios.push(currCriterio);
      });
      this.evaluacionMetas.push(currMeta);
    });
    this.setEvaluacion(alumno, fechas);
  }

  setEvaluacion(alumno, fechas) {
    this.evaluacionMetas.map(meta => {
      meta.criterios.map(criterio => {
        fechas.map(fecha => {
          criterio.niveles.map(nivel => {
            const normalDate = fecha.substring(0, 10),
              currNivel = nivel.fechas.find(nivelFecha => {
                return nivelFecha.label === normalDate;
              }),
              // FIXME: No tenemos fecha en el nuevo modelo de criterios
              evaluacionesFecha = alumno.criterios.filter(criterioAlumno => {
                return criterioAlumno.fecha.substring(0, 10) === normalDate;
              });
            evaluacionesFecha.map(evaluacion => {
              const criterioEvaluado = Object.assign({}, currNivel.criterios.find(critEval => {
                  return critEval.id === evaluacion.criterioId;
                })),
                criterioIndex = currNivel.criterios.findIndex(critEval => {
                  return critEval.id === evaluacion.criterioId;
                });
              criterioEvaluado.isSeleccionado = true;
              currNivel.criterios[criterioIndex] = criterioEvaluado;
            });
          });
        });
      });
    });
  }

  openEval(metaID, criterioID, nivelID, fecha = '') {
    const metaEval = Object.assign({}, this.evaluacionMetas.find(meta => meta.id == metaID));
    metaEval.criterios = Object.assign({}, metaEval.criterios.find(criterio => criterio.id == criterioID));
    metaEval.criterios.niveles = Object.assign({}, metaEval.criterios.niveles.find(nivel => nivel.id == nivelID));
    const fechaEval = metaEval.criterios.niveles.fechas.find(fechaN => {
      return fechaN.label === fecha;
    });
    metaEval.criterios.niveles.criterios = Object.assign([], fechaEval.criterios);

    const dialogRef = this.matDialog.open(RetroalimentacionMiEvaluacionComponent, {
      width: '75%',
      data: {meta: metaEval},
      disableClose: true
    });
  }
}
